import { Eye } from "lucide-react";

export default function Logo({ size = "md" }) {
  const dims = {
    sm: { icon: 18, text: "text-xl sm:text-2xl", gap: "gap-2.5" },
    md: { icon: 22, text: "text-2xl sm:text-3xl", gap: "gap-3" },
    lg: { icon: 28, text: "text-3xl sm:text-4xl", gap: "gap-3" },
  }[size] || { icon: 22, text: "text-2xl sm:text-3xl", gap: "gap-3" };

  return (
    <div className={`flex items-center ${dims.gap} select-none`} data-testid="useen-logo">
      <div className="relative shrink-0">
        <div className="absolute inset-0 blur-md bg-gradient-to-br from-cyan-400 to-purple-500 opacity-60 rounded-full" />
        <div className="relative w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 flex items-center justify-center shadow-[0_0_18px_rgba(59,130,246,0.45)]">
          <Eye size={dims.icon} className="text-white" strokeWidth={2} />
        </div>
      </div>
      <span className={`font-display font-extrabold tracking-tight leading-none ${dims.text} text-white`}>
        u<span className="gradient-text">Seen</span>
      </span>
    </div>
  );
}
